module.exports = __webpack_public_path__ + "img/type(4).3fdee6fa.png";